<div *ngIf="pageDesignFlag">
  <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style">
    
    <div class="row" id="start-action-button-container" *ngIf="pageDesign.back_button && enableBackBtn">
        <img src="assets/images/back-arrow.png" class="back-button" alt="" srcset="" (click)="previousQstn()">
    </div>
    
    <!-- CUSTOM CODE SECTION -->
    <div *ngIf="customDesign" [ngStyle]="survey_screen_style">

      <div [innerHTML]="quizSteps | sanitizeHtml" #customDesign *ngIf="quizSteps!=undefined"></div>
      <div [innerHTML]="htmlText | sanitizeHtml" #customDesign></div>
      
    </div>

      <!-- NON CUSTOM CODE SECTION -->
    <div *ngIf="!customDesign" [ngStyle]="survey_screen_style">

      <div *ngFor="let ele of pageDesign.element_flow" style="width: 100%;">
      
        <p *ngIf="ele.type=='text' && question!=null && question!=''" [ngStyle]="ele.style" [innerHTML]="question | sanitizeHtml"></p>

        <img *ngIf="ele.type=='image' && qst_img_obj!= null" src="{{qst_img_obj.src}}" alt="" srcset="" [ngStyle]="qst_img_obj.style">
        
        <img *ngIf="ele.type=='secondary-image' && qst_img_obj!= null" src="{{qst_img_obj.src}}" alt="" srcset="" [ngStyle]="ele.style">
        
        <p *ngIf="ele.type=='sub-text' && subText!= 'null' && subText!= undefined" [ngStyle]="ele.style" [innerHTML]="subText | sanitizeHtml"></p>
        
        <div *ngIf="ele.type=='custom'" [innerHTML]="ele.custom_html | sanitizeHtml"></div>
          
        <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
        (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml"></button>

        <div *ngIf="ele.type=='multi-option'">
        
          <mat-button-toggle-group appearance="legacy" class="example-radio-group" name="fontStyle" aria-label="Font Style"
            [(ngModel)]="selectedOption" [multiple]="multi_selection">
        
            <mat-button-toggle class="example-radio-button mat-raised-button options_btn" *ngFor="let opt of currentQstOptions" 
              [value]="opt.optID" #selectionBtn (click)="loadNext(opt,ele,selectionBtn)" [ngStyle]="opt.opt_style" [title]="opt.optVal.title">
              <img *ngIf="opt.optVal.img !=='null' && opt.optVal.img !==''" src="{{opt.optVal.img.i_url}}" alt="" class="option-img" srcset="" [ngStyle]="opt.img_style">
              
              <img *ngIf="opt.api_data != undefined && opt.api_data.highlight_type == 'image'" src="{{aiPoweredImgUrl}}" alt="" class="option-img" srcset="" [ngStyle]="aiPoweredImgStyle">
            
              <div>
                <span>
              
                  <div [ngStyle]="opt.text_style" [innerHTML]=opt.optVal.val></div>
                  
                  <span *ngIf="opt.api_data != undefined">
                    <sup class="ai-sup" *ngIf="opt.api_data !=undefined && opt.api_data.highlight_type == 'text'">AI</sup>
                    <span class="button_border_text" *ngIf="opt.api_data !=undefined && opt.api_data.highlight_type == 'button_border_text'" [ngStyle]="ai_highlight_text_style" i18n>Selected by AI</span>
                  </span> 
    
                </span>
    
              </div>
            
            </mat-button-toggle>
            
            <div *ngIf="enableNextBtn" id="cont-btn-container">
                <div *ngIf="surveyContinueButton!=null">
                <button mat-raised-button  type="button" (click)="continueBtn()" [ngStyle]="surveyContinueButton.style" #surveyContinue [innerHTML]="surveyContinueButton.text | sanitizeHtml"></button>
                </div>
                <div *ngIf="surveyContinueButton==null">
                  <button mat-raised-button  type="button" (click)="continueBtn()" [ngStyle]="this.customService.getSurveyNextButtonStyle()" #surveyContinue>Continue</button>
                </div>
            </div>

            <div *ngIf="surveySkip!=null" id="cont-btn-container">
              
              <button mat-raised-button [ngStyle]="surveySkip.style"
              (click)="skipQuestion()" [innerHTML]="surveySkip.text | sanitizeHtml"></button>

            </div>

          
          </mat-button-toggle-group>
      
        </div>

        <button type="button" mat-raised-button *ngIf="ele.type=='button' && pageDesign.type !='survey_screen'" [ngStyle]="ele.style"
        (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml"></button>

      </div>

      <!-- FORM ENTRY IN SURVEY -->
      <form [formGroup]="form" *ngIf="form_present" >

        <div *ngFor="let field of form_fields" style="width: 100%;">
            
          <div *ngIf="field.category=='form_input'">

            <div [ngSwitch]="field.type">

              <div class="input-div" *ngSwitchCase="'text'">
          
                <mat-form-field appearance = "{{field.matApperance}}">
          
                  <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
          
                  <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value" matInput  [ngStyle]="field.style"  [required]="field.required">
          
                  <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>
                  
                </mat-form-field>
          
              </div>

              <div class="input-div" *ngSwitchCase="'number'">
              
                <mat-form-field appearance = "{{field.matApperance}}">
          
                  <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
          
                  <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value" matInput  [ngStyle]="field.style" [required]="field.required">
          
                  <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                </mat-form-field>

              </div>
              
              <div class="input-div" *ngSwitchCase="'dropdown'">
          
                <select [formControlName]="field.key" [id]="field.key"  class="select-box">
          
                  <option disabled>{{field.label}}</option>
          
                  <option *ngFor="let opt of field.options" placeholder="field.label" [value]="field.key">{{field.key}}</option>
                
                </select>
              
              </div>

              <div  class="input-div" *ngSwitchCase="'textarea'">
                
                <mat-form-field appearance="{{field.matApperance}}">
                
                  <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
                
                  <textarea [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value" matInput [rows]="field.rowcount" [ngStyle]="field.style"  [required]="field.required"></textarea>
                
                  <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                </mat-form-field>
              
              </div>
              
              <div class="input-div" *ngSwitchCase="'date'">

                <mat-form-field appearance = "{{field.matApperance}}">
                  
                  <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
                  
                  <input [formControlName]="field.key" [min]="field.minDate" [max]="field.maxDate" (focus)="picker.open()" (click)="picker.open()" [value]="field.value" [id]="field.key" matInput [matDatepicker]="picker" (keydown)="false"  [ngStyle]="field.style"  [required]="field.required">
                  
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  
                  <mat-datepicker #picker></mat-datepicker>

                </mat-form-field>
          
              </div>

              <div class="input-div" *ngSwitchCase="'email'">
          
                <mat-form-field appearance = "{{field.matApperance}}">
          
                  <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
          
                  <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value" matInput  [ngStyle]="field.style"  [required]="field.required">
          
                  <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                </mat-form-field>
          
              </div>

            </div>

          </div>
          
          <button type="button" mat-raised-button *ngIf="field.category=='form_submit'" [ngStyle]="field.style"
          (click)="submitFormFunction(field,form)" [disabled]="form.status == 'INVALID'">{{field.text}}</button>
    
        </div>
        
      </form>

    </div>

  </div>
</div>